
import React, {  } from 'react'
import { SearchIcon, CogIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";

const applications = [{ type: 'Collateral Coverage Ratio', value: '120%' },
{ type: 'Interest Rate Spread', value: '10%' },
{ type: 'Annual Percentage Rate (APR)', value: '₦20,000.00' },
{ type: 'Management Fee', value: '1%' },
{ type: 'Insurance Fee', value: '0%' },
{ type: 'Withholding Tax (WHT)', value: '0%' },
{ type: 'Minimum Loan Amount', value: '₦50,000.00' },
{ type: 'Maximum Loan Amount', value: '₦200,000,000.00' },
{ type: 'Minimum Loan Tenor', value: '1 month' },
{ type: 'Maximum Loan Tenor', value: 'Maximum Loan Tenor' },
{ type: 'Repayment Date', value: '' }
]


export default function CashbasedSettings() {
    return (<>
        <Layout title={'Parameters Settings'} current={'/cash/settings'} pageTag={'loans'}>
            <React.Fragment>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                    <div className="sm:flex sm:items-center mt-10">
                        <div className="sm:flex-auto flex">
                            <div className="mt-1 relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </div>
                                <input
                                    type="text"
                                    name="user"
                                    id="user"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                    placeholder="Search customer"
                                />
                            </div>
                            <div className="mt-1 relative rounded-md shadow-sm ml-3">
                                <select
                                    id="currency"
                                    name="currency"
                                    placeholder="Sort by"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                >
                                    <option>Sort by</option>
                                    <option>Name</option>
                                    <option>Account Type</option>
                                </select>

                            </div>
                        </div>

                        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none flex">
                            <button
                                type="button"
                                className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                            <button className='border border-dark rounded-md btn-secondary px-2'>
                                <CogIcon className='w-8' />
                            </button>
                        </div>
                    </div>

                    <div className="mt-8 flex flex-col">
                        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                            <div className="inline-block w-3/4 py-2 align-middle md:px-6 lg:px-8">
                                <div className='mt-5 grid'>
                                    <div className='flex justify-between'>
                                        <p className='text-xs mb-2'>Setting type</p>
                                        <p className='text-xs mb-2'>Value</p>
                                    </div>
                                    <div className="bg-white shadow overflow-hidden sm:rounded-md">
                                        <ul role="list" className="divide-y divide-gray-200">
                                            {applications.map((application) => (
                                                <li>
                                                    <a className="block hover:bg-gray-50">
                                                        <div className="flex items-center  py-4 ">
                                                            <div className="min-w-0 flex-1 flex items-center">

                                                                <div className="min-w-0 flex-1 px-2 md:grid  md:gap-4">

                                                                    <div className="hidden md:block">
                                                                        <div>
                                                                            <p className="text-sm text-gray-900">
                                                                                {application.type}
                                                                            </p>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mr-2.5 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900">
                                                                {application.value}
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        </Layout></>)

}